/** *
 *      ┌─┐       ┌─┐ + +
 *   ┌──┘ ┴───────┘ ┴──┐++
 *   │                 │
 *   │       ───       │++ + + +
 *   ███████───███████ │+
 *   │                 │+
 *   │       ─┴─       │
 *   │                 │
 *   └───┐         ┌───┘
 *       │         │
 *       │         │   + +
 *       │         │
 *       │         └──────────────┐
 *       │                        │
 *       │                        ├─┐
 *       │                        ┌─┘
 *       │                        │
 *       └─┐  ┐  ┌───────┬──┐  ┌──┘  + + + +
 *         │ ─┤ ─┤       │ ─┤ ─┤
 *         └──┴──┘       └──┴──┘  + + + +
 *                神兽保佑
 *               代码无BUG!
 */
import App from './App.vue'
import { createApp } from 'vue'
import { router, setupRouter, setupRouterGuard } from './router'
import { setupStore } from './store'
import { registerPlugins } from '@/plugins'
import { appName, appVersion, isDev } from './utils'
import '@/styles/index.less'

async function bootstrap() {
  const app = createApp(App)
  /**
   * Configure store
   */
  setupStore(app)

  /**
   * Register global plugins
   */
  registerPlugins(app)

  /**
   * Configure routing
   */
  setupRouter(app)
  /**
   * Configure route guard
   */
  setupRouterGuard()
  await router.isReady()
  app.mount('#app', true)
  if (isDev) {
    app.config.performance = true
    window.__APP__ = app
  }
}
bootstrap()

console.log(
  `%c  <%- ${appName} %>@<%- ${appVersion} %>  %c  @copyright 成都百刀科技有限公司 service@baidaokeji.cn  `,
  'color: #fadfa3; background: #030307; padding:5px 0;',
  'background: #fadfa3; padding:5px 0;'
)
